import { ref, watch } from '@vue/composition-api'
import useRouter from '../useRouter'
import {dashboardUtils} from '../../utils'

const useFilters = () => {

    const {router, route} = useRouter();

    const filters = ref(route.value.query.filters ? JSON.parse(route.value.query.filters) : {})

    const resetFilters = () => {
        filters.value = {}
    }

    const setFilter = (key, val) => {
        filters.value = {
            ...filters.value,
            [key]: key === 'status' ? val && val.toLowerCase() : val
        };
    }

    watch(filters, filters => {

        let query = {
            ...route.value.query,
        }

        if(Object.keys(filters).length){
            query  = {
                ...query,
                id: undefined,
                filters:JSON.stringify({...filters})
            }
        } else {
            query.filters = undefined
        }

        router.replace({
            query
        }).catch(() => {})
        
    })

    watch(route, (newRoute, oldRoute) => {
        if(newRoute.query.id){
            resetFilters();
        }

        if(oldRoute && oldRoute.query.type !== newRoute.query.type) {
            resetFilters()
        }

        
    })

    return {
        filters,
        resetFilters,
        setFilter
    }
}

export default useFilters
